import { Button } from "@trillion/ui/components/ui/button";
import type { CollaborationStatus as Status } from "../types/board";

const labels: Record<Status, string> = { connecting: "Connecting", connected: "Connected", reconnecting: "Reconnecting",
  disconnected: "Disconnected", degraded: "Live updates interrupted — recovering" };
export function CollaborationStatus({ status, onRetry, unavailable = false }: { status: Status; onRetry: () => void; unavailable?: boolean }) {
  return <div className="flex flex-wrap items-center gap-2 text-xs text-foreground">
    <span role="status" aria-live="polite">{unavailable ? "Diagram unavailable" : labels[status]}</span>
    {!unavailable && status !== "connected" && <Button size="sm" variant="outline" onClick={onRetry}>Retry connection</Button>}
  </div>;
}
